// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"4c569d7b","171":"ea9a4d95","480":"a9f4d18a"}[chunkId] + ".chunk.js";
};